import styled from "@emotion/styled";

// const Base = ({ className : any }) => <div className={className}>Some text</div>

export const UserPicStyles = styled("div")`
  .pic {
    &__meta {
      display: flex;
      align-items: center;
    }

    &__avatar {
      min-width: 40px;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      background-color: #734299;

      display: flex;
      justify-content: center;
      align-items: center;
      font-weight: 600;
    }

    &__avatar-text {
      color: #fff;
    }
  }
`;
